<template>
  <div class="successVip">
    <div class="successBack" @click.stop="returnExercise">
      <img src="@/assets/icon/icon_left.png"  alt="">
    </div>
    <div class="returnExercise" @click.stop="returnExercise">返回开始练习</div>
    <hot-cases ref="hotMedicase"></hot-cases>

  </div>
</template>
<script>
import { defineComponent } from 'vue'
import hotCases from '@/components/exercise/hot-cases/index.vue'
import { isLogin, getUserId, userLogin, hiddenAppNavBar, appPort } from '@/widget/index'
import { createExerciseOrder } from '@api/meeting'
import { userMedicaseOverview } from '@api/exercise'
export default defineComponent({
  components: {
    hotCases
  },
  methods: {
    returnExercise () {
      if (this.$router.hasRoute('medicaseHome')) {
        history.go(-1)
      } else {
        this.$router.replace({
          name: 'medicaseHome'
        })
      }
    }
  },
  mounted () {
    if (appPort()) {
      hiddenAppNavBar()
    }
    var userId = getUserId() || '';
    var sourceId = this.$route.query.sourceId || '0'
    var depId = this.$route.query.depId || '';
    if (isLogin && /\d+/.test(userId)) {
      this.$showLoading()
      userMedicaseOverview({
        departmentId: depId
      }).then(res => {
        // 判断用户是否有领取资格
        if (res.code === 200) {
          if (res.data.role === 'GUEST') {
            depId = depId || res.data.departmentId || ''
            createExerciseOrder({
              userId
            }, {
              exerciseId: res.data.skuId,
              sourceId,
              depId
            }).then(res => {
              if (res.code === 200) {
                setTimeout(() => {
                  this.$toast('领取成功')
                  this.$hideLoading()
                  this.$refs.hotMedicase.hotMedicase()
                }, 1200)
              } else {
                this.$toast(res.message)
              }
            })
          } else {
            this.$toast('您已领取过体验课!')
          }
        } else {
          this.$toast(res.message)
        }
      })
    } else {
      userLogin()
    }
  }
})
</script>

<style lang="scss" scoped>
.successVip {
  width: 7.5rem;
  background: #f5f5f7;
  min-height: 100vh;
  .successBack {
    width: 7.5rem;
    height: 5.06rem;
    background: url('~@/assets/img/exercise/successVip.png') no-repeat;
    background-size: 100% 100%;
    img {
      width: 0.25rem;
      height: 0.48rem;
      margin: 0.4rem 0 0 0.32rem;
    }
  }
  .returnExercise {
    width: 5.66rem;
    height: 0.88rem;
    background: #eeba78;
    border-radius: 0.44rem;
    margin: 0.48rem 0.92rem 0.64rem;
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #794000;
    line-height: 0.88rem;
    text-align: center;
  }
}
</style>
